module.exports = __webpack_public_path__ + "static/img/serverShop5.76949dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/supplyHome/serverShop5.png
// module id = avl4
// module chunks = 2